'use client';

import PurchaseAuthSelector from '@/features/auth/components/PurchaseAuthSelector/PurchaseAuthSelector';
import styles from '@/features/auth/components/SignInContainer/SignInContainer.module.scss';
import SignInForm from '@/features/auth/components/SignInForm/SignInForm';
import { useGlobalLoadingAtom } from '@/state';
import { useEffect } from 'react';

function SignInContainer({
  callbackUrl,
}: {
  callbackUrl: string;
}) {
  const [, , , forceStopGlobalLoading] = useGlobalLoadingAtom();

  //NOTE:サインインページ表示中にnextAuthで禁止されているページに遷移するとロード表示になってしまうので強制的にローディングを停止する
  useEffect(() => {
    forceStopGlobalLoading();
  }, [forceStopGlobalLoading]);

  // 購入フローの場合は購入専用の認証選択画面を表示
  const isPurchaseFlow = callbackUrl === '/purchase';

  return (
    <div className={styles.componentStyle}>
      {isPurchaseFlow ? <PurchaseAuthSelector callbackUrl={callbackUrl} /> : <SignInForm callbackUrl={callbackUrl} />}
    </div>
  );
}

export default SignInContainer;
